// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ow78","requiredAsterisk":"Info_requiredAsterisk__3Y6NO"};